module.exports = __webpack_public_path__ + "static/img/organism-h5-2.1de99f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/organism-h5-2.png
// module id = C1dZ
// module chunks = 34